<div class="rs-maxh rs-padding-bottom2" data-cy="nortonAntiTheftSection">
  <div class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col">
    <h3 class="rs-tit6">{{ 'norton.antitheft.title' | translate }}</h3>
    <p [innerHTML]="'norton.antitheft.desc' | translate: true"></p>
    <div class="rs-me"></div>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <p>
        <a
          href="{{ 'norton.antitheft.link.url' | translate }}"
          target="_blank"
          data-tms-event="link-click"
          attr.data-tms-link-zone="{{ 'norton.antitheft.title' | translate }}"
          attr.data-tms-link-name="{{ 'norton.antitheft.link.clickHere' | translate }} {{
            'norton.antitheft.link.label' | translate
          }}"
          attr.data-tms-link-url="{{ 'norton.antitheft.link.url' | translate }}"
        >
          {{ 'norton.antitheft.link.clickHere' | translate }}</a
        >&nbsp;{{ 'norton.antitheft.link.label' | translate }}
      </p>
    </div>
  </div>
</div>
